import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'
import { Dashboardv99990101Api } from '@sequencehq/api/dashboard/v99990101'

export type NotificationPolicy = NonNullable<
  Awaited<
    ReturnType<typeof dashboard20240730Client.getNotificationPolicy>
  >['data']
>

type NotificationType = Dashboardv99990101Api.Notifications.NotificationType

export type NotificationPolicyValidFormData = {
  name: string
  recipients: string[]
  notificationTypes: NotificationType[]
}

export const ALL_NOFITICATION_TYPES: NotificationType[] = [
  'CUSTOMER_CREATED',
  'CUSTOMER_UPDATED',
  'CUSTOMER_ARCHIVED',
  'CUSTOMER_ALIAS_CREATED',
  'CUSTOMER_ALIAS_UPDATED',
  'CUSTOMER_ALIAS_DELETED',
  'INVOICE_CREATED',
  'INVOICE_ISSUED',
  'INVOICE_UPDATED',
  'BILLING_SCHEDULE_CREATED',
  'BILLING_SCHEDULE_UPDATED',
  'BILLING_SCHEDULE_ARCHIVED',
  'CREDIT_NOTE_CREATED',
  'CREDIT_NOTE_UPDATED',
  'CREDIT_NOTE_ISSUED',
  'QUOTE_PUBLISHED',
  'QUOTE_ACCEPTED',
  'QUOTE_SIGNED',
  'MERCHANT_UPDATED'
]

// Dunning notification types: webhook-only and gated behind the
// `useAutomationsDunning` feature flag until dunning is fully released.
export const DUNNING_WEBHOOK_NOTIFICATION_TYPES: NotificationType[] = [
  'INVOICE_REMINDER_SENT',
  'WATCHTOWER_TASK_ASSIGNED'
]

export const getNotificationTypesForChannel = (
  channel: 'EMAIL' | 'WEBHOOK',
  dunningEnabled: boolean
): NotificationType[] => {
  const includeDunningTypes = channel === 'WEBHOOK' && dunningEnabled

  return includeDunningTypes
    ? [...ALL_NOFITICATION_TYPES, ...DUNNING_WEBHOOK_NOTIFICATION_TYPES]
    : ALL_NOFITICATION_TYPES
}

const notificationTypeToReadableName = (key: NotificationType) => {
  return key
    .toLowerCase()
    .split('_')
    .map((word, i) =>
      i === 0 ? word.charAt(0).toUpperCase() + word.slice(1) : word
    )
    .join(' ')
}

export const getNotificationSummary = (
  enabledNotifications?: NotificationType[]
) => {
  if (!enabledNotifications || !enabledNotifications.length) {
    return 'Enabled for all notifications'
  }

  const readableNames = enabledNotifications.map(notificationTypeToReadableName)
  const shown = readableNames.slice(0, 2)
  const remaining = readableNames.length - shown.length

  if (readableNames.length === 1) {
    return `Enabled for ${shown[0]}`
  }

  if (readableNames.length === 2) {
    return `Enabled for ${shown[0]} and ${shown[1]}`
  }

  return `Enabled for ${shown[0]}, ${shown[1]}, and ${remaining} other${remaining > 1 ? 's' : ''}`
}

export const hasSelectedAllNotificationTypes = (
  notificationTypes: NotificationType[],
  channel: 'EMAIL' | 'WEBHOOK',
  dunningEnabled: boolean
) => {
  const notificationTypesSet = new Set(notificationTypes)
  return getNotificationTypesForChannel(channel, dunningEnabled).every(item =>
    notificationTypesSet.has(item)
  )
}
